import { View, SxProp } from "dripsy";
import { ViewProps } from "react-native";

interface RowProps extends ViewProps {
  sx?: SxProp;
}

export const Row: React.FC<RowProps> = (props) => {
  return <View {...props} sx={{ ...styles.container, ...props.sx }} />;
};

enum StyleName {
  container = "container",
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flex: 1,
    flexDirection: "row",
  },
};
